export default __webpack_public_path__ + "static/media/new-white-logo.88d6e6fb.svg";